import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RechazosTracesNoCumplimientoViewModel, TNTRetrievalAttachmentViewModel } from '../rechazostraces.types';
import { ComponentBase } from '../../../../core/_infrastructure/classes/componentBase';
import { FormGroup } from '@angular/forms';
import { NotificationService } from '../../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../../core/_infrastructure/classes/handlers/exceptionManager';

@Component({
    selector: 'app-rechazostraces-no-cumplimiento',
    templateUrl: './rechazostraces-no-cumplimiento.component.html',
})
export class RechazosTracesNoCumplimientoComponent extends ComponentBase implements OnInit, OnChanges {
    @Input() formGroup: FormGroup;
    @Input() rechazoTracesNoCumplimiento: RechazosTracesNoCumplimientoViewModel;

    @Output() download = new EventEmitter<any | null>();

    isCollapsedMotivosRechazo = false;
    isCollapsedMedidasAdoptadas = false;
    isCollapsedDocumentosRelacionados = false;
    isCollapsedLugarInspeccion = false;
    isCollapsedTipoInspeccion = false;

    numeroMedidas = 0;
    numeroMotivos = 0;
    numeroDocumentos = 0;

    colsMedidas: any[];
    colsMotivos: any[];
    colsDocumentos: any[];

    tipoLugarInspeccion = '';

    idRowMotivo = 0;
    idRowMedida = 0;

    constructor(
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        //protected rechazosTracesService: RechazosTracesService,
        public datepipe: DatePipe,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.colsMedidas = [
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'Extension', header: 'Extensión' },
            { field: 'FechaInicioCuarentena', header: 'Fecha inicio de cuarentena' },
            { field: 'FechaFinPrevistaCuarentena', header: 'Fecha fin prevista de cuarentena' },
            { field: 'FechaFinCuarentena', header: 'Fecha fin de cuarentena' },
            { field: 'LugarCuarentena', header: 'Lugar de cuarentena' },
            { field: 'PaisCuarentena', header: 'País de cuarentena' },
            { field: 'MedidaProductosEmbalajes', header: 'Productos y/o embalajes' },
        ];

        this.colsMotivos = [
            { field: 'Descripcion', header: 'Descripción' },
            { field: 'Extension', header: 'Extensión' },
            { field: 'MotivoProductosEmbalajes', header: 'Productos y/o embalajes' },
            { field: 'Observacion', header: 'Observación' },
            { field: 'OrganismoNocivo', header: 'Organismo nocivo' },
            { field: 'OrganismoNocivoNoEspecie', header: 'Organismo nocivo no especie' },
            { field: 'OrganismoNocivoNoReguladoUE', header: 'Organismo nocivo no regulado UE' },
        ];

        this.colsDocumentos = [
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Referencia', header: 'Referencia' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'Pais', header: 'País' },
            //{ field: 'Tipo', header: 'Tipo' },
            { field: 'Link', header: 'Link' },
        ];

        this.updateForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.rechazoTracesNoCumplimiento?.currentValue) {
            this.numeroMedidas = this.rechazoTracesNoCumplimiento.MedidasList.length;
            this.numeroMotivos = this.rechazoTracesNoCumplimiento.MotivosList.length;
            this.numeroDocumentos = this.rechazoTracesNoCumplimiento.Documentos.length;

            let primeraLetraMayuscula = this.rechazoTracesNoCumplimiento?.TipoLugarInspeccion?.charAt(0).toUpperCase();
            let restoDeLetras = this.rechazoTracesNoCumplimiento?.TipoLugarInspeccion?.slice(1);
            this.tipoLugarInspeccion = primeraLetraMayuscula + restoDeLetras;

            this.rechazoTracesNoCumplimiento.MotivosList.forEach(mo => {
                mo.IdRowMotivo = this.idRowMotivo++;
            });

            this.rechazoTracesNoCumplimiento.MedidasList.forEach(me => {
                me.IdRowMedida = this.idRowMedida++;
            });

            this.updateForm();

            this.rechazoTracesNoCumplimiento?.Documentos.forEach(res => {
                this.onCheckEnableDownloadButtonAvailable(res);
            });
        }
    }

    private updateForm(): void {
        this.formGroup.patchValue({
            MotivosList: this.rechazoTracesNoCumplimiento?.MotivosList,
            MedidasList: this.rechazoTracesNoCumplimiento?.MedidasList,
            ComentarioMedidas: this.rechazoTracesNoCumplimiento?.ComentarioMedidas,
            CiudadInspeccion: this.rechazoTracesNoCumplimiento?.CiudadInspeccion,
            CodigoISOInspeccion: this.rechazoTracesNoCumplimiento?.CodigoISOInspeccion,
            CodigoPostalInspeccion: this.rechazoTracesNoCumplimiento?.CodigoPostalInspeccion,
            DireccionInspeccion: this.rechazoTracesNoCumplimiento?.DireccionInspeccion,
            NombreInspector: this.rechazoTracesNoCumplimiento?.NombreInspector,
            PaisInspeccion: this.rechazoTracesNoCumplimiento?.PaisInspeccion,
            FechaTipoInspeccion: this.datepipe.transform(this.rechazoTracesNoCumplimiento?.FechaTipoInspeccion, 'dd/MM/yyyy'),
            PFC: this.rechazoTracesNoCumplimiento?.PFC,
            TipoLugarInspeccion: this.tipoLugarInspeccion,
            TipoInspControlSeguimientoNoSintomas: this.rechazoTracesNoCumplimiento?.TipoInspControlSeguimientoNoSintomas,
            TipoInspControlSeguimientoSiSintomas: this.rechazoTracesNoCumplimiento?.TipoInspControlSeguimientoSiSintomas,
            TipoInspSupervisionPuestoInsp: this.rechazoTracesNoCumplimiento?.TipoInspSupervisionPuestoInsp,
            Unlocode: this.rechazoTracesNoCumplimiento?.Unlocode,
            Documentos: this.rechazoTracesNoCumplimiento?.Documentos,
        });

        this.form = this.formGroup;
    }

    onDownload(item: any): void {
        let model = new TNTRetrievalAttachmentViewModel();
        let id = item?.Link;

        model.CHEDPP = this.rechazoTracesNoCumplimiento.CHEDPP;
        model.DocumentId = Number(id);
        model.FileName = item.Nombre;

        this.download.emit(model);
    }

    onCheckEnableDownloadButtonAvailable(item: any): void {
        let model = new TNTRetrievalAttachmentViewModel();
        let id = item?.Link;

        model.DocumentId = Number(id);

        if (model.DocumentId === 0 || Number.isNaN(model.DocumentId)) {
            item.DownloadButtonAvailable = false;
        }
    }
}
